import { Outlet } from 'react-router-dom';

export function DevelopersLayout() {
  return (
    <div className="dev-shell">
      <header className="dev-topbar">
        <a href="/" className="dev-topbar__brand">
          Permio<span>.</span>
        </a>
        <nav className="dev-topbar__nav">
          <span className="dev-topbar__link dev-topbar__link--active">Documentation</span>
          <a
            href="http://localhost:3001/api/docs"
            className="dev-topbar__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Référence API ↗
          </a>
        </nav>
        <div className="dev-topbar__right">
          <a href="/login" className="btn btn--primary btn--sm">
            Se connecter
          </a>
        </div>
      </header>
      <Outlet />
    </div>
  );
}

export default DevelopersLayout;
